import styled from 'styled-components'

/*
 * The fixed cells after a grid's columns — the line's documents, its saved
 * status, its actions — decided in one place for the header and the rows.
 *
 * They must be the same on both sides. Flex shares a shortfall out among the
 * cells that may shrink, by their width: a cell that shrinks in the header but
 * not in the rows (or one with a border on one side only) hands the columns a
 * different share above than below, and the columns drift apart as the grid
 * narrows. So none of these shrink, none carry a border, and the first one
 * takes up the slack of a wide grid on both sides alike.
 */
export const trailingCellsOf = (config) => {
    const hasActions = config.lineActions?.menuItems?.length > 0 || !!config.path
    return [
        ...(config.lineDocuments ? [{ id: 'documents', width: '36px' }] : []),
        ...(hasActions ? [{ id: 'status', width: '20px' }, { id: 'actions', width: '40px' }] : [])
    ]
}

export const TrailingCell = styled.div`
    flex: 0 0 ${({ $len }) => $len};
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-left: ${({ $first }) => $first ? 'auto' : '0'};
`
